import { styled } from 'helpers';
import { Typography } from 'Typography';

import { LabelType, StyledLabelProps } from './types';

const isContactType = (
  type?:
    | 'teammate'
    | 'secondary'
    | 'primary'
    | 'general'
    | 'business'
    | 'unsaved'
    | 'work'
    | 'mobile'
    | 'home'
    | 'other',
) => {
  return (
    type === LabelType.Work ||
    type === LabelType.Mobile ||
    type === LabelType.Home ||
    type === LabelType.Other
  );
};

export const Label = styled(Typography)<StyledLabelProps>`
  box-sizing: border-box;
  border-radius: 4px;
  display: inline-block;
  height: ${({ type }) => (isContactType(type) ? '16px' : '20px')};
  padding: ${({ type }) => (isContactType(type) ? '2px 4px' : '2px 8px')};

  ${({ theme, type }) => {
    const customStyle: Record<
      | 'teammate'
      | 'secondary'
      | 'primary'
      | 'general'
      | 'business'
      | 'unsaved'
      | 'work'
      | 'mobile'
      | 'home'
      | 'other',
      string
    > = {
      teammate: `
        background-color: ${theme.palette.secondary.main};
        color: ${theme.palette.secondary.contrastText};
      `,
      secondary: `
        background-color: ${theme.palette.secondary.main};
        color: ${theme.palette.secondary.contrastText};
      `,
      business: `
        background-color: ${theme.palette.yellow[600]};
        color: ${theme.palette.secondary.contrastText};
      `,
      primary: `
        background-color: ${theme.palette.blue[50]};
        color: ${theme.palette.primary.main};
      `,
      general: `
        background-color: ${theme.palette.blue[50]};
        color: ${theme.palette.primary.main};
      `,
      unsaved: `
        background-color: ${theme.palette.blueGrey['A600']};
        color: ${theme.palette.primary.contrastText};
      `,
      work: `
        background-color: ${theme.palette.lightBlue[50]};
        color: ${theme.palette.lightBlue[900]};
      `,
      mobile: `
        background-color: ${theme.palette.lightGreen[50]};
        color: ${theme.palette.secondary.contrastText};
      `,
      home: `
        background-color: ${theme.palette.purple[50]};
        color: ${theme.palette.purple[900]};
      `,
      other: `
        background-color: ${theme.palette.teal[50]};
        color: ${theme.palette.teal[900]};
      `,
    };

    return customStyle[type ?? 'primary'];
  }}
`;
export default Label;
